import { render, staticRenderFns } from "./FeatureBlock.vue?vue&type=template&id=7f6807df&scoped=true"
import script from "./FeatureBlock.vue?vue&type=script&lang=js"
export * from "./FeatureBlock.vue?vue&type=script&lang=js"
import style0 from "./FeatureBlock.vue?vue&type=style&index=0&id=7f6807df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6807df",
  null
  
)

export default component.exports